import React, { useState, useRef } from 'react'; // ✅ include useRef
import * as XLSX from 'xlsx';
import axios from 'axios';
import Swal from 'sweetalert2';

const DeleteLRUpload = () => {
  const [lrNos, setLrNos] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);


  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onload = (evt) => {
      const data = evt.target?.result;
      const workbook = XLSX.read(data, { type: 'array' }); // use array type
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(sheet, { defval: '' });

      const extractedLrNos = jsonData
        .map((row: any) => row.LR_NO?.toString()?.trim())
        .filter((lr: string | undefined) => lr);

      console.log("Extracted LR_NO values:", extractedLrNos);
      setLrNos(extractedLrNos as string[]);
    };

    reader.readAsArrayBuffer(file); // ✅ modern reliable format
  };

  const handleDelete = async () => {
    if (lrNos.length === 0) {
      Swal.fire('No LR Numbers', 'Please upload a file with LR_NO values.', 'warning');
      return;
    }

    try {
      console.log("Delete button clicked with LRNOs:", lrNos);
      setLoading(true);

      const response = await axios.post('http://localhost:2600/delete-lrnos', {
        lrNos: lrNos, // Send as array
      });

      if (response.data.success) {
        Swal.fire('Deleted!', response.data.message, 'success');
        setLrNos([]);

        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
      } else {
        Swal.fire('Failed', response.data.message, 'error');
      }
    } catch (error: any) {
      Swal.fire('Error', error.response?.data?.message || error.message || 'Failed to delete records.', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '30px', maxWidth: '500px', margin: 'auto' }}>
      <h3>🗑️ Delete LR_NO via Excel</h3>

      <input
        ref={fileInputRef}
        type="file"
        accept=".xlsx, .xls"
        onChange={handleFileChange}
        className="form-control mb-3"
      />

      <button
        onClick={handleDelete}
        disabled={loading || lrNos.length === 0}
        className="btn btn-danger"
      >
        {loading ? 'Deleting...' : 'Delete Records'}
      </button>

      {lrNos.length > 0 && (
        <div className="mt-3">
          <p><strong>{lrNos.length}</strong> LR_NO(s) ready to delete.</p>
        </div>
      )}
    </div>
  );
};

export default DeleteLRUpload;
